import React from 'react';
import './Footer.css';
import { FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import Logo from "../assets/logoR.png"
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-section">
        <div className="footer-logo"><img src={Logo}/></div>
        <p className="footer-contact">
          📞 6389421663<br />
          📞 8533873389<br />
          ✉️ stap1603@gmail.com
        </p>
      </div>

      <div className="footer-section">
        <h4>Important Links</h4>
        <ul>
          <li><a href="/terms" target="_blank">Terms of Use</a></li>
          <li><a href="/privacy" target="_blank">Privacy Policy</a></li>
          <li><a href="/downloads" target="_blank">Downloads</a></li>
          <li><a href="/contact" target="_blank">Contact</a></li>
        </ul>
      </div>

      <div className="footer-section">
        <h4>Follow Us</h4>
        <div className="social-icons">
          <a href="https://instagram.com/single._.tap" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
